/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-imports */
import axios from 'axios';
import { from, defer } from 'rxjs';
/** Aspera Starter Axios wrapper for creating Observable based Axios */
class AsperaAxios {
    constructor() {
        this.axios = axios.create();
    }
    getUri(config) {
        return defer(() => from(this.axios.getUri(config)));
    }
    request(config) {
        return defer(() => from(this.axios.request(config)));
    }
    get(url, config) {
        return defer(() => from(this.axios.get(url, config)));
    }
    delete(url, config) {
        return defer(() => from(this.axios.delete(url, config)));
    }
    head(url, config) {
        return defer(() => from(this.axios.head(url, config)));
    }
    options(url, config) {
        return defer(() => from(this.axios.options(url, config)));
    }
    post(url, data, config) {
        return defer(() => from(this.axios.post(url, data, config)));
    }
    put(url, data, config) {
        return defer(() => from(this.axios.put(url, data, config)));
    }
    patch(url, data, config) {
        return defer(() => from(this.axios.patch(url, data, config)));
    }
    postForm(url, data, config) {
        return defer(() => from(this.axios.postForm(url, data, config)));
    }
    putForm(url, data, config) {
        return defer(() => from(this.axios.putForm(url, data, config)));
    }
    patchForm(url, data, config) {
        return defer(() => from(this.axios.patchForm(url, data, config)));
    }
}
export const Axios = new AsperaAxios();
